export const CATEGORY_TRUCK = 'CATEGORY_TRUCK';
